import { useContext, useState } from 'react';
import StandardizedDataTable from '../../PrimeAids/StandardizedDataTable';
import { ReportContext } from '../../../context/ReportContext';
import { dataRollUp } from '../../PlotlyAids/dataRollUps';
import { formatDateToIsoExtDate, userColumns } from '../../../helpers';
import ReportLineChart from '../../PlotlyAids/ReportLineChart';
import ReportChartLayoutWrapper from '../../PlotlyAids/ReportChartLayoutWrapper';
import ExpandableInfoCard, {
    ExpandableInfoCardDescription,
    ExpandableInfoCardDetail,
} from '../../Cards/ExpandableInfoCard';

export const userCoursesColumns = [
    {
        field: 'title',
        name: 'Course Title',
        dataType: 'multiselect',
        styles: { minWidth: '20rem' },
    },
    { field: 'startDatetime', name: 'Start Date ({tz} time zone)', dataType: 'datetime' },
    { field: 'finishDatetime', name: 'Finish Date ({tz} time zone)', dataType: 'datetime' },
    { field: 'preScore', name: 'Pre Score', dataType: 'numeric' },
    { field: 'postScore', name: 'Post Score', dataType: 'numeric' },
    { field: 'preFeeling', name: 'Pre Feeling', dataType: 'multiselect' },
    { field: 'postFeeling', name: 'Post Feeling', dataType: 'multiselect' },
    { field: 'completionStatus', name: 'Completed', dataType: 'multiselect' },
];

const UserCourses = () => {
    const { reportData } = useContext(ReportContext);

    const columns = [...userColumns, ...userCoursesColumns];

    const [filteredData, setFilteredData] = useState([]);

    // const rolledUp = dataRollUp(
    //     filteredData,
    //     (row) => formatDateToIsoExtDate(row.startDatetime),
    //     {
    //         count: true,
    //     }
    // );

    // const chartData = [
    //     {
    //         name: 'Total Courses',
    //         x: rolledUp.map((x) => x.groupByField),
    //         y: rolledUp.map((x) => x.count),
    //     },
    // ];

    return (
        <div className="space-y-6">
            <StandardizedDataTable
                data={reportData}
                columns={columns}
                onValueChange={setFilteredData}
            />
            {/* <ReportChartLayoutWrapper>
                <ReportLineChart data={chartData} chartTitle="User Courses Over Time" />
            </ReportChartLayoutWrapper> */}

            <ExpandableInfoCard title="What is this data?">
                <ExpandableInfoCardDescription>
                    This report shows detailed information about courses users have
                    started or completed.
                </ExpandableInfoCardDescription>
                <ExpandableInfoCardDetail name="Course Title">
                    The name of the course.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Start Date">
                    When the user began the course.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Finish Date">
                    When the user completed the course (if applicable).
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Pre Score">
                    The user's knowledge assessment score before starting the course.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Post Score">
                    The user's knowledge assessment score after completing the course.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Pre Feeling">
                    The user's self-reported confidence or sentiment before the course.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Post Feeling">
                    The user's self-reported confidence or sentiment after the course.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Completed">
                    Whether the user has finished the course or not.
                </ExpandableInfoCardDetail>
            </ExpandableInfoCard>
        </div>
    );
};

export default UserCourses;
